import Act2020AllStar from '@/assets/jce/Act2020AllStarServant.js';
import {data} from '@/data.js';
import './wsChannel';
import { fetchProd, getURLParam } from '@tools/func.ts';
declare global {
  interface Window {
    Taf: any
  }
}
// const staticClose = getURLParam('mock') !== '1';
const staticClose = false;
const Taf = window.Taf || null;
const callWup: (moduleName: string, funcName: string, data: any, unpackFun: any) => Promise<any> = (moduleName, funcName, data, unpackFun) => {
  const TestURL = 'http://testws.va.huya.com?timestamp=';
  const ProdURL = 'https://cdnws.api.huya.com?timestamp=';
  const URL = true ? ProdURL : TestURL;
  const wup = new Taf.Wup();
  wup.setServant(moduleName);
  wup.setFunc(funcName);
  wup.writeStruct('tReq', data);
  const buffer = wup.encode().getBuffer();
  const timestamp = new Date().getTime();
  return new Promise((resolve, reject) => {
    Taf.Util.ajax(URL + timestamp,
      buffer,
      (value: any) => {
        const rsp = new Taf.Wup();
        rsp.decode(value);
        const result = new unpackFun();
        rsp.readStruct('tRsp', result, unpackFun);
        // console.log(funcName, data, result);
        resolve(result);
      },
      (res: any) => {
        reject(res);
      });
  })
}
const tafFetch = (moduleName: string, data: any, requ: any, resp: any) => {
  console.log('静态化错误');
  const req = requ === null ? null : new requ();
  Object.keys(data).forEach(key => {
    req[key] = data[key];
  })
  return callWup('wupui', moduleName, req, resp);
}
const random = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min)) + min;
}
const RankItemMock: (count: number) => RankItem[] = count => {
  let data = [];
  for(let i = 0 ; i < count ; i++) {
    let lUid = random(9999999, 100000)
    data.push({
      iRank: i + 1,       // 排名
      lScore: random(0, 99999999),      // 分数
      sNickName: random(0, count) +  '随机昵称随机昵称',   // 昵称
      sLogoUrl: '',    // 头像
      tJump: {
        lPid: lUid,       // 主播Uid
        lTid: 0,          // 频道Tid
        lSid: 0,          // 频道Sid
        iGameId: 0,       // 品类id
        lYYId: 0,         // YY
        iRoomId: random(0, 99999),    // roomid
        bIsLive: random(0, 99999999) % 2 === 0,      // 是否在播
      },
      iPromoteStatus: 0,
      sDesc: '娱乐全明星活动期间，tab默认定位在五大国民偶像上，五大国民偶像和最强交友天团都可以打开娱乐全明星活动期间，tab默认定位在五大国民偶像上，五大国民偶像和最强交友天团都可以打开',
      iStarIdol: 0,
      sPortraitUrl: '',
    })
  }
  data = data.sort((prev, next) => next.lScore - prev.lScore);
  for(let i = 0 ; i < count ; i++) {
    data[i].iRank = i + 1;
  }
  return data;
}

/* 公共结构体 */
export interface RankItem {
  iRank: number,       // 排名
  lScore: number,      // 分数
  sNickName: string,   // 昵称
  sLogoUrl: string,    // 头像
  tJump: JumpChannel,       // 跳转
  iPromoteStatus?: number, // 0=正常状态, 1=在晋级区, 2=已经晋级, 3=已淘汰
  sDesc?: string,     // 描述信息(扩展字段，五大主播榜时用)
  iStarIdol?: number  // 1=是明星偶像，0=不是明星偶像
  sPortraitUrl?: string,  // 肖像URL
}
export interface JumpChannel {
  lPid: number,       // 主播Uid
	lTid: number,       // 频道Tid
	lSid: number,       // 频道Sid
	iGameId: number,    // 品类id
	lYYId: number,      // YY
	iRoomId: number,    // roomid
	bIsLive: boolean,      // 是否在播
}
export interface StageRankPanel {
  iAreaId: number,    // (1= 游戏区，2=娱乐区)
  iSubAreaId: number, // 子分区id(1~13)
  vRankList: {        // 榜单列表
    value: RankItem[],
  }
}
export interface AreaInfo {
  iSubAreaId: number,
  sAreaName: string,
  iState: number, // 0-可以报名  1-不能报名
}


// 获取阶段
type StageInfoReq = (
  option: {
    lPid: number,
  }
) => Promise<StageInfoRsp>
export interface StageInfoRsp {
  iAreaId: number,  // 主播所在大区(1-娱乐, 2-游戏)
  iSubAreaId: number, // 主播所在分区(娱乐 1-18, 游戏 1-13)
  iEntStage: number,  // 娱乐目前的阶段
  iGameStage: number, // 游戏目前的阶段
  sAreaName: string,
}
const StarGetStageInfo: StageInfoReq = option => {
  if (staticClose) return tafFetch('StarGetStageInfo', option, Act2020AllStar.StageInfoReq, Act2020AllStar.StageInfoRsp);
  return new Promise(resolve => {
    resolve(data.StarGetStageInfo);
    // resolve({
    //   iAreaId: 0,
    //   iSubAreaId: 0,
    //   iEntStage: 7,
    //   iGameStage: 7,
    //   sAreaName: '',
    // })
  })
}

// 分区获取
type AreaInfoReq = (
  option: {
    lPid: number,
  }
) => Promise<AreaInfoRsp>
export interface AreaInfoRsp {
  vGameArea: {
    value: AreaInfo[],
  },
  vEntArea: {
    value: AreaInfo[],
  },
}
const StarGetAreaInfo: AreaInfoReq = option => {
  if (staticClose) return tafFetch('StarGetAreaInfo', option, Act2020AllStar.AreaInfoReq, Act2020AllStar.AreaInfoRsp);
  return new Promise(resolve => {
    resolve(data.StarGetAreaInfo);
    // const data = [];
    // const datas = [];
    // const list1 = ["综艺一哥", "综艺一姐","好声音歌手", "王牌脱口秀", "灵魂舞者", "性感女王", "清纯女神", "甜美萝莉", "街头霸王", "打野鬼才", "次元偶像", "颜值担当", "食神", "音乐才子", "星火之光", "交友星光", "交友殿堂", "交友荣耀"]
    // const list2 = ["荣耀王者", "峡谷冠军","精英战神", "电竞女王", "宅男女神", "游戏萌主", "联盟之光", "云顶圣手", "绝地枪神", "头号玩家", "竞技之王", "网游导师", "手游先锋"]

    // for(let i = 0 ; i < 13 ; i++) {
    //   datas.push({
    //     iSubAreaId: i + 1,
    //     sAreaName: list2[i],
    //     iState:  i % 3 === 0 ? 1 : 0,
    //   })
    // }
    // for(let i = 0 ; i < 18 ; i++) {
    //   data.push({
    //     iSubAreaId: i + 1,
    //     sAreaName: list1[i],
    //     iState:  i % 2 === 0 ? 1 : 0,
    //   })
    // }
    // resolve({
    //   vGameArea: {
    //     value: datas,
    //   },
    //   vEntArea: {
    //     value: data,
    //   },
    // })
  })
}

// 海选阶段
type AuditionRankReq = (
  option: {
    iAreaId: number,  // (1-游戏, 2-娱乐)
    iSubAreaId: number,   // 子分区id(1~13)
    lPid?: number,     // 0
  }
) => Promise<AuditionRankRsp>
export interface AuditionRankRsp {
  sDesc: string,  // 晋级提示
  tPanel: StageRankPanel, // 主播所在分区(娱乐 1-18, 游戏 1-13)
  tItem?: RankItem,
}
const StarGetAuditionRank: AuditionRankReq = option => {
  if (staticClose) return tafFetch('StarGetAuditionRank', option, Act2020AllStar.AuditionRankReq, Act2020AllStar.AuditionRankRsp);
  return new Promise(resolve => {
    resolve(data.StarGetAuditionRank['iAreaId' + option.iAreaId]['iSubAreaId' + option.iSubAreaId]);
    // resolve({
    //   sDesc: '国庆加班国庆加班国庆加班国庆加班国庆加班国庆加班国庆加班',
    //   tPanel: {
    //     iAreaId: option.iAreaId,    // (1= 游戏区，2=娱乐区)
    //     iSubAreaId: option.iSubAreaId, // 子分区id(1~13)
    //     vRankList: {        // 榜单列表
    //       value: RankItemMock(50),
    //     }
    //   },
    // })
  })
}

// 淘汰阶段
type EliminateRankReq = (
  option: {
    iAreaId: number,  // (1-游戏, 2-娱乐)
    iSubAreaId: number,   // 子分区id(1~13)
  }
) => Promise<EliminateRankRsp>
export interface EliminateRankRsp {
  sDescA: string,  // 晋级提示
  sDescB: string,
  tPanelA: StageRankPanel, // A
  tPanelB: StageRankPanel, // B
}
const StarGetEliminationRank: EliminateRankReq = option => {
  if (staticClose) return tafFetch('StarGetEliminationRank', option, Act2020AllStar.EliminateRankReq, Act2020AllStar.EliminateRankRsp);
  return new Promise(resolve => {
    resolve(data.StarGetEliminationRank['iAreaId' + option.iAreaId]['iSubAreaId' + option.iSubAreaId]);
    // resolve({
    //   sDescA: 'a国庆加班国庆加班国庆加班国庆加班国庆加班国庆加班国庆加班',
    //   sDescB: 'b国庆加班国庆加班国庆加班国庆加班国庆加班国庆加班国庆加班',
    //   tPanelA: {
    //     iAreaId: option.iAreaId,    // (1= 游戏区，2=娱乐区)
    //     iSubAreaId: option.iSubAreaId, // 子分区id(1~13)
    //     vRankList: {        // 榜单列表
    //       value: RankItemMock(50),
    //     }
    //   },
    //   tPanelB: {
    //     iAreaId: option.iAreaId,    // (1= 游戏区，2=娱乐区)
    //     iSubAreaId: option.iSubAreaId, // 子分区id(1~13)
    //     vRankList: {        // 榜单列表
    //       value: RankItemMock(50),
    //     }
    //   }
    // })
  })
}

// 擂台赛阶段
type RingRankReq = (
  option: {
    iAreaId: number,  // (1-游戏, 2-娱乐)
    iSubAreaId: number,   // 子分区id(1~13)
  }
) => Promise<RingRankRsp>
export interface RingRankRsp  {
  tPanel: StagePairRankPanel,  // 1v1 面板
  tLoser: StageRankPanel, // 败者面板
}
export interface StagePairRankPanel {
  iAreaId: number,    // (1= 游戏区，2=娱乐区)
  iSubAreaId: number, // 子分区id(1~13)
  vRankList: {
    value: PairRankItem[],
  }  // 榜单列表
}
export interface PairRankItem {
  tLeftItem: RankItem,
  tRightItem: RankItem,
}
const StarGetRingRank: RingRankReq  = option => {
  if (staticClose) return tafFetch('StarGetRingRank', option, Act2020AllStar.RingRankReq, Act2020AllStar.RingRankRsp );
  return new Promise(resolve => {
    resolve(data.StarGetRingRank['iAreaId' + option.iAreaId]['iSubAreaId' + option.iSubAreaId]);
    // resolve({
    //   tLoser: {
    //     iAreaId: option.iAreaId,    // (1= 游戏区，2=娱乐区)
    //     iSubAreaId: option.iSubAreaId, // 子分区id(1~13)
    //     vRankList: {        // 榜单列表
    //       value: RankItemMock(6),
    //     }
    //   },
    //   tPanel: {
    //     iAreaId: option.iAreaId,    // (1= 游戏区，2=娱乐区)
    //     iSubAreaId: option.iSubAreaId, // 子分区id(1~13)
    //     vRankList: {
    //       value: [
    //         {
    //           tLeftItem: RankItemMock(1)[0],
    //           tRightItem: RankItemMock(1)[0],
    //         },
    //         {
    //           tLeftItem: RankItemMock(1)[0],
    //           tRightItem: RankItemMock(1)[0],
    //         },
    //         {
    //           tLeftItem: RankItemMock(1)[0],
    //           tRightItem: RankItemMock(1)[0],
    //         },
    //         {
    //           tLeftItem: RankItemMock(1)[0],
    //           tRightItem: RankItemMock(1)[0],
    //         },
    //       ],
    //     } 
    //   }
    // })
  })
}

// 决赛阶段
type FinalRankReq = (
  option: {
    iAreaId: number,  // (1-游戏, 2-娱乐)
    iSubAreaId: number,   // 子分区id(1~13)
  }
) => Promise<FinalRankRsp>
export interface FinalRankRsp {
  sDesc: string,  // 晋级提示
  tPanel: StageRankPanel, //
}
const StarFinalRank: FinalRankReq = option => {
  if (staticClose) return tafFetch('StarFinalRank', option, Act2020AllStar.FinalRankReq, Act2020AllStar.FinalRankRsp);
  return new Promise(resolve => {
    resolve(data.StarFinalRank['iAreaId' + option.iAreaId]['iSubAreaId' + option.iSubAreaId]);
    // resolve({
    //   sDesc: '国庆加班国庆加班国庆加班国庆加班国庆加班国庆加班国庆加班',
    //   tPanel: {
    //     iAreaId: option.iAreaId,    // (1= 游戏区，2=娱乐区)
    //     iSubAreaId: option.iSubAreaId, // 子分区id(1~13)
    //     vRankList: {        // 榜单列表
    //       value: RankItemMock(25),
    //     }
    //   },
    // })
  })
}


// 神豪榜单
type RichRankReq  = (
  option: {
    iAreaId: number,  // 主播所在大区(1-娱乐, 2-游戏)
  }
) => Promise<RichRankRsp>
export interface RichRankRsp  {
  tPanel: StageRankPanel,  // 主播所在大区(1-娱乐, 2-游戏)
}
const StarGetRichRank: RichRankReq = option => {
  if (staticClose) return tafFetch('StarGetRichRank', option, Act2020AllStar.RichRankReq, Act2020AllStar.RichRankRsp);
  return new Promise(resolve => {
    resolve(data.StarGetRichRank['iAreaId' + option.iAreaId]);
    resolve({
      tPanel: {
        iAreaId: option.iAreaId,    // (1= 游戏区，2=娱乐区)
        iSubAreaId: 0, // 子分区id(1~13)
        vRankList: {        // 榜单列表
          value: RankItemMock(50),
        }
      },
    })
  })
}

// 五大榜单
type TopRankReq = (
  option: {
    iAreaId: number,  // 1： 电竞 2：偶像  3：交友
  }
) => Promise<TopRankRsp>
export interface TopRankRsp {
  tPanel: StageRankPanel,
  sDesc: string,
}
const StarGetTopRank: TopRankReq = option => {
  if (staticClose) return tafFetch('StarGetTopRank', option, Act2020AllStar.TopRankReq, Act2020AllStar.TopRankRsp);
  return new Promise(resolve => {
    resolve(data.StarGetTopRank['iAreaId' + option.iAreaId]);
    // resolve({
    //   tPanel: {
    //     iAreaId: 0,
    //     iSubAreaId: 0,
    //     vRankList: {        // 榜单列表
    //       value: RankItemMock(10),
    //     }
    //   },
    //   sDesc: '国庆加班加班国庆加班加班国庆加班加班国庆加班加班国庆加班加班',
    // })
  })
}


// 获取主播报名信息
type RegisterStateReq = (
  option: {
    lPid: number,
  }
) => Promise<RegisterStateRsp>
export interface RegisterStateRsp {
  iAreaId: number,
  tInfo: AreaInfo,
}
const StarGetRegisterState: RegisterStateReq = option => {
  if (staticClose) return tafFetch('StarGetRegisterState', option, Act2020AllStar.RegisterStateReq, Act2020AllStar.RegisterStateRsp);
  return new Promise(resolve => {
    resolve({
      iAreaId: 1,
      tInfo: {
        iSubAreaId: 14,
        sAreaName: '测试啊啊',
        iState: 0,
      },
    })
  })
}


// 报名
export interface Register {
  lPid?: number,
  iType: number,
  iArea: number,
  sAreaName?: string,
}
export type RegisterReq = (
  option: {
    lPid: number,
    iAreaId: number,
    iSubAreaId: number,
  }
) => Promise<RegisterRsp>
export interface RegisterRsp {
  iAreaId: number,
  iSubAreaId: number,
  iRes: number,
  sDesc: string,
}
const StarRegister: RegisterReq = option => {
  if (staticClose) return tafFetch('StarRegister', option, Act2020AllStar.RegisterReq, Act2020AllStar.RegisterRsp);
  return new Promise(resolve => {
    resolve({
      iAreaId: option.iAreaId,
      iSubAreaId: option.iSubAreaId,
      iRes: 0,  // 报名结果 0: 成功  非0-其他
      sDesc: '成功个屁!',
    })
  })
}


const fetch = {
  StarGetRegisterState,
  StarGetAreaInfo,
  StarRegister,
  StarGetStageInfo,
  StarGetAuditionRank,
  StarGetEliminationRank,
  StarGetRingRank,
  StarFinalRank,
  StarGetRichRank,
  StarGetTopRank,
}
export {
  fetch,
}
